import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/core/utilities.service';
import {DataService} from "../../data.service";

@Component({
  selector: 'app-ai-content-generator-inner',
  templateUrl: './ai-content-generator-inner.component.html',
  styleUrls: ['./ai-content-generator-inner.component.scss'],
})
export class AiContentGeneratorInnerComponent implements OnInit {
  store_id;
  bearer;
  isLoading;
  dataIsLoading;

  constructor(
    private svc: StoreService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    public utils: UtilitiesService,
    private dataService: DataService
  ) {}

  selectedTemplate;
  selectedTemplateParams;
  params = {};
  generatedContent = '';
  info;

  ngOnInit(): void {
    this.store_id = localStorage.getItem('store_id');
    this.bearer = localStorage.getItem('bearer');
    this.dataIsLoading = true;
    const templateName = this.utils.aiContentGenerator?.input?.templateName;
    this.info = JSON.parse(localStorage.getItem(('5s-info')));

    this.svc
      .getAITemplateDetails({
        type: templateName,
      })
      .subscribe(
        (res: any) => {
          this.selectedTemplateParams = res.data;
          this.dataIsLoading = false;
          this.initDefaultOptionValues();
        },
        (error) => {
          this.dataIsLoading = false;
        },
        () => {
          this.dataIsLoading = false;
        }
      );

    this.selectedTemplate = templateName;

    console.log('Init AI content generator');
  }

  initDefaultOptionValues() {
    const templateParams = this.selectedTemplateParams;
    const presetParams = this.utils.aiContentGenerator?.input?.presetParams;

    if (templateParams?.['parameter_data'] !== undefined) {
      let defaultParams = {};

      Object.entries(templateParams['parameter_data']).forEach(
        (element: any) => {
          const [elKey, elValue] = element;
          if (elValue?.type === 'string') {
            defaultParams[elKey] =
              presetParams?.[elKey] ?? elValue.values[0]?.optionValue ?? '';
          } else if (elValue?.type === 'number') {
            defaultParams[elKey] = presetParams[elKey] ?? elValue?.min ?? 0;
          } else {
            defaultParams[elKey] = '';
          }
        }
      );

      this.params = defaultParams;
    }
  }

  getOptions() {
    const templateParams = this.selectedTemplateParams;

    if (templateParams?.['parameter_data'] === undefined) {
      return [];
    } else {
      return Object.keys(templateParams['parameter_data']);
    }
  }

  getOptionSelections(optionName) {
    const templateParams = this.selectedTemplateParams;
    const templateParamsData = templateParams?.['parameter_data']?.[optionName];
    if (templateParamsData !== undefined) {
      const selections = templateParamsData['values'];
      return selections;
    } else {
      return [];
    }
  }

  isOptionVisible(optionName) {
    const templateParams = this.selectedTemplateParams;
    const templateParamsData = templateParams?.['parameter_data']?.[optionName];
    return !(!!templateParamsData.hidden === true);
  }

  getOptionValue(option) {
    return this.params[option];
  }

  getOptionLabelByValue(option, value) {
    const optionData = this.getOptionSelections(option);
    const foundOption = optionData.find(
      (option) => option.optionValue?.toLowerCase() === value?.toLowerCase()
    );
    if (foundOption) {
      return foundOption['optionLabel'];
    } else {
      return value;
    }
  }

  setOptionValue(option, value) {
    return (this.params[option] = value);
  }

  useDropdownOption(optionName) {
    const templateParams = this.selectedTemplateParams;

    if (templateParams?.['parameter_data'] !== undefined) {
      return Object.entries(templateParams['parameter_data']).some(
        (element: any) => {
          const [elKey, elValue] = element;
          return (
            elKey === optionName &&
            elValue?.type === 'string' &&
            elValue?.values?.length > 0
          );
        }
      );
    }
    return false;
  }

  generateContent() {
    this.isLoading = true;
    const params = this.params;
    params['type'] = this.selectedTemplate;
    params['desc'] = this.utils.aiContentGenerator?.input?.presetParams?.desc;
    console.log({params});
    this.svc.getAIGeneratedContent(params).subscribe(
      (res: any) => {
        console.log('res', { res });
        this.generatedContent = res?.data;
        this.getDealerCredit();

        this.isLoading = false;
      },
      (error) => {
        const errorMsg = this.utils.getErrorMessageWithRefId(
          error,
          'Unknown error, kindly contact our eStore team to check'
        );
        this.utils.notify.showError(errorMsg, 'Error!');
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  getDealerCredit() {
    this.svc.getDealerCredit(this.bearer, this.info.d_id).subscribe(
      (res: any) => {
        this.dataService.updateDealerCredits(res['data']);
      },
      (error) => {
        const errorMsg = this.utils.getErrorMessageWithRefId(
          error,
          'Unknown error, kindly contact our eStore team to check'
        );
        this.utils.notify.showError(errorMsg, 'Error!');
      }
    );
  }

  useGeneratedContent() {
    this.utils.aiContentGenerator?.input?.onChange(this.generatedContent);
    this.closeModal();
  }

  formatLabel(labelName) {
    return labelName.replace(/[^a-zA-Z0-9\s]/g, ' ');
  }

  closeModal() {
    this.activeModal.close('Modal Closed');
  }
}
